import { render, staticRenderFns } from "./EmailButtons.vue?vue&type=template&id=0986c2b6&scoped=true&"
import script from "./EmailButtons.vue?vue&type=script&lang=js&"
export * from "./EmailButtons.vue?vue&type=script&lang=js&"
import style0 from "./EmailButtons.vue?vue&type=style&index=0&id=0986c2b6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0986c2b6",
  null
  
)

export default component.exports